import React from 'react';
import { Placeholder, SearchPageTitle } from 'components/Search/StyledComponents';
import Clock from 'components/Clock';
import SearchIcon from 'components/Icons/search';
import i18n from 'i18n';

export const SearchPlaceholder = ({ description }) => {
  return (
    <>
      <SearchPageTitle>{i18n.t('search.title')}</SearchPageTitle>
      <Placeholder>
        <Clock />
        <SearchIcon />
        <span>{description}</span>
      </Placeholder>
    </>
  );
};
